export const loadingConstants = {
  SUCCESS: 'LOADING_SUCCESS',
  ERROR: 'LOADING_ERROR',
  PENDING: 'LOADING_PENDING',
  AMOUNTLOADED: 'LOADING_AMOUNT_LOADED',
  TOTALLOADED: 'LOADING_TOTAL_LOADED',
  ISSPINNER: 'LOADING_SPINNER',
  LOADINGPROCESS: 'LOADINGPROCESS',
};
